/**
 * @param {object} date1
 * @param {object} date2
 * @return {int|undefined}
 */
function getDiffBetweenDatesInDays (date1, date2) {
  if (!date1 || !date2) return
  if (
    Object.prototype.toString.call(date1) !== '[object Date]' ||
    Object.prototype.toString.call(date2) !== '[object Date]'
  ) return

  const oneDayMs = 1000 * 60 * 60 * 24
  const diffMs = date2.getTime() - date1.getTime()

  return Math.round(diffMs / oneDayMs)
}

module.exports = { getDiffBetweenDatesInDays }
